import { ReactNode } from 'react';
import { AppFormItem, ConditionalRender } from 'components/atoms';
import {
    CityInputElement,
    InstitutionAffiliationPickerElement,
    InstitutionNameInputElement,
    NurseryRegisterNumberInputWithFetchElement,
    RegonInputWithFetchElement,
    RspoNumberInputElement,
    SimpleSelectElement,
    StreetAddressInputElement,
    ZipCodeInputElement,
} from 'components/molecules';
import { InstitutionAddEditFormFields, InstitutionType } from 'types';
import { authTexts } from 'consts/text';
import { institutionTypeItems } from 'consts/institution/institutionType';
import { formFields } from 'consts/form/formFields';
import useForm from 'antd/es/form/hooks/useForm';
import { useWatch } from 'antd/es/form/Form';
import { AppForm, AppFormProps } from '../AppForm/AppForm';

export type InstitutionAddFormProps = AppFormProps<InstitutionAddEditFormFields> & {
    formNavButtons: ReactNode;
    mode: 'add' | 'edit';
};

const institutionTypesWithRegonFetching: InstitutionType[] = ['KINDERGARTEN', 'SCHOOL', 'OTHER'];
const institutionTypesWithNurseryRegistryNumberFetching: InstitutionType[] = [
    'KIDS_CLUB',
    'NURSERY',
];

export const InstitutionAddEditForm = ({
    formNavButtons,
    mode,
    form,
    ...props
}: InstitutionAddFormProps) => {
    const [formInstance] = useForm(form);

    const institutionTypeFormValue = useWatch<InstitutionType | undefined>(
        formFields.institutionType,
        formInstance,
    );

    const isEditMode = mode === 'edit';
    const isRegonFetchingEnabled = institutionTypeFormValue
        ? institutionTypesWithRegonFetching.includes(institutionTypeFormValue)
        : false;
    const isNurseryRegistryNumberFetchingEnabled = institutionTypeFormValue
        ? institutionTypesWithNurseryRegistryNumberFetching.includes(institutionTypeFormValue)
        : false;
    const formTitle = isEditMode ? 'Edytuj placówkę' : 'Dodaj placówkę';

    return (
        <AppForm<InstitutionAddEditFormFields> title={formTitle} form={formInstance} {...props}>
            <SimpleSelectElement
                name={formFields.institutionType}
                label={authTexts.institutionTypeLabel}
                options={institutionTypeItems}
            />
            <ConditionalRender condition={isRegonFetchingEnabled}>
                <RegonInputWithFetchElement />
            </ConditionalRender>
            <ConditionalRender condition={isNurseryRegistryNumberFetchingEnabled}>
                <NurseryRegisterNumberInputWithFetchElement />
            </ConditionalRender>
            <InstitutionNameInputElement />
            <ConditionalRender condition={isRegonFetchingEnabled}>
                <RspoNumberInputElement />
            </ConditionalRender>
            <StreetAddressInputElement />
            <AppFormItem justifyContent="space-between" doubleItem>
                <ZipCodeInputElement />
                <CityInputElement />
            </AppFormItem>
            <InstitutionAffiliationPickerElement />
            {formNavButtons}
        </AppForm>
    );
};
